class IntlService {
  static DEFAULT_LOCALE = 'en';

  static hasLocaleNotSet(token) {
    return token === null || token === 'undefined';
  }

  static setLocale(userLocale) {
    localStorage.setItem('user_locale', userLocale);
  }

  static getLocale() {
    const userLocale = localStorage.getItem('user_locale');
    return IntlService.hasLocaleNotSet(userLocale) ? IntlService.DEFAULT_LOCALE : userLocale;
  }
}

export default IntlService;
